import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { StyledBreadcrumb } from '../../components/breadcrumb/breadcrumb';
import { IShipTo, ISoldTo } from '../../graphql/types';
import { HOME_PAGE_ROUTE } from '../home/page';
import { soldToRoute } from '../sold-to/route';

export const OrderDetailsBreadcrumbs: FC<{
  shipTo?: IShipTo;
  soldTo: ISoldTo;
}> = ({ shipTo, soldTo }) => {
  return (
    <StyledBreadcrumb>
      <li>
        <Link to={HOME_PAGE_ROUTE}>Home</Link>
      </li>
      <li>
        <Link to={soldToRoute(soldTo.id, {})}>
          Sold To: {soldTo.address.name} {soldTo.id}
        </Link>
      </li>
      <li>
        {soldTo.salesOrg !== 'SG88' && soldTo.salesOrg !== 'US86' ? (
          <Link to={soldToRoute(soldTo.id, { shipToId: shipTo?.id })}>
            Ship To: {shipTo?.address.name} {shipTo?.id}
          </Link>
        ) : (
          'Ship To: ' + shipTo?.address.name + shipTo?.id
        )}
      </li>
      <li>Order details</li>
    </StyledBreadcrumb>
  );
};
